import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { coerceHttpParams } from 'src/app/shared/flight-log-api/shared/create-request-options';
import { AppState } from 'src/store';
import { UpsertAircraftMakeModels } from 'src/store/aircraft-make-model/aircraft-make-model.actions';
import { AircraftMakeModelEntity } from 'src/store/aircraft-make-model/aircraft-make-model.model';
import { AircraftMakeModelViewModel } from 'src/view-models/aircraft-make-model-view-model';
import { FlightLogApiConfiguration, FLIGHT_LOG_API_CONFIG } from '../flight-log-api-configuration';
import { CollectionResult } from '../flight-logs/flight-log-client-model-helpers';

export interface AircraftMakeModels<T extends AircraftMakeModelEntity = AircraftMakeModelEntity>
  extends CollectionResult<T> {}

@Injectable({ providedIn: 'root' })
export class AircraftMakeModelHttpClient {
  constructor(
    @Inject(FLIGHT_LOG_API_CONFIG) private config: FlightLogApiConfiguration,
    private http: HttpClient,
    private _store: Store<AppState>,
  ) {}

  public getAll(params: {
    id?: string;
    codeLike?: string;
    skip?: number;
    take?: number;
  }): Observable<AircraftMakeModels<AircraftMakeModelViewModel>> {
    return this.http
      .get<AircraftMakeModels>(this._url('aircraftMakeModels'), {
        params: coerceHttpParams({
          ...params,
        }),
      })
      .pipe(
        tap(({ results: aircraftMakeModels }) => {
          this._store.dispatch(new UpsertAircraftMakeModels({ aircraftMakeModels }));
        }),
        map((res) => {
          return {
            results: res.results.map((r) => new AircraftMakeModelViewModel(r)),
            totalCount: res.totalCount,
          };
        }),
      );
  }

  private _url(path: string) {
    return this.config.baseUri + '/api/' + path;
  }
}
